import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const appConfigurationRequest = createAction(
  types.APP_CONFIGURATION_REQUEST,
);
export const appConfigurationSuccess = createAction(
  types.APP_CONFIGURATION_SUCCESS,
);
export const appConfigurationFailure = createAction(
  types.APP_CONFIGURATION_FAILURE,
);

export const createAppConfigurationRequest = createAction(
  types.CREATE_APP_CONFIGURATION_REQUEST,
);
export const createAppConfigurationSuccess = createAction(
  types.CREATE_APP_CONFIGURATION_SUCCESS,
);
export const createAppConfigurationFailure = createAction(
  types.CREATE_APP_CONFIGURATION_FAILURE,
);

export const updateAppConfigurationRequest = createAction(
  types.UPDATE_APP_CONFIGURATION_REQUEST,
);
export const updateAppConfigurationSuccess = createAction(
  types.UPDATE_APP_CONFIGURATION_SUCCESS,
);
export const updateAppConfigurationFailure = createAction(
  types.UPDATE_APP_CONFIGURATION_FAILURE,
);

export default {
  appConfigurationRequest,
  appConfigurationSuccess,
  appConfigurationFailure,
  createAppConfigurationRequest,
  createAppConfigurationSuccess,
  createAppConfigurationFailure,
  updateAppConfigurationRequest,
  updateAppConfigurationSuccess,
  updateAppConfigurationFailure,
};
